import { paymentSchema, type CancelPaymentBody, type Payment } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postCancel = (id: string, body: CancelPaymentBody): Promise<unknown> =>
  apiRequest<unknown>(`/payments/${id}/cancel`, { method: 'POST', body });

export const cancelPayment = async (id: string, body: CancelPaymentBody): Promise<Payment> =>
  paymentSchema.parse(await postCancel(id, body));
